export default "__VITE_ASSET__B$qRCUEU__"